module.exports = __webpack_public_path__ + "img/cpl-sml-pc.6b55e84c.jpg";